import React from "react";

function UpdateLeaveForm({ item, onCancel, onSubmit }) {
	const outCome = React.createRef();
	const planAction = React.createRef();
	const evaluate = React.createRef();
	const contact = React.createRef();
	const mental = React.createRef();
	setTimeout(() => {
		if (outCome && outCome.current) outCome.current.value = item.leave_outcome;
		if (planAction && planAction.current)
			planAction.current.value = item.plan_action;
		if (evaluate && evaluate.current)
			evaluate.current.value = item.evaulate_leave;
		if (contact && contact.current)
			contact.current.value = item.contact_tel_number;
		if (mental && mental.current)
			mental.current.value = item.mental_state_assessment_detail;
	}, 0);
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				onSubmit({
					id: item.id,
					mental: mental.current.value,
					contact: contact.current.value,
					evaulate: evaluate.current.value,
					planAction: planAction.current.value,
					outcome: outCome.current.value
				});
			}}
		>
			<div className="form-group m-t-20">
				<label htmlFor="mental-assessment-id">
					Mental state Assessment Details
				</label>
				<textarea
					name="mental-assessment-id"
					id="mental-assessment-id"
					ref={mental}
					className="form-control form-control-textarea"
					required
					rows="6"
					placeholder="enter mental state description"
				></textarea>
			</div>
			<div className="form-group m-t-20">
				<label htmlFor="contact-phone-id">Contact Telephone Number</label>
				<input
					name="contact-phone-id"
					text="text"
					id="contact-phone-id"
					ref={contact}
					className="form-control input-height"
					required
					placeholder="enter telephone number"
				/>
			</div>
			<div className="form-group m-t-20">
				<label htmlFor="evaluate-leave-id">Evaluate Leave</label>
				<textarea
					name="evaluate-leave-id"
					id="evaluate-leave-id"
					className="form-control form-control-textarea"
					required
					ref={evaluate}
					rows="6"
					placeholder="enter leave evaluation"
				></textarea>
			</div>
			<div className="form-group m-t-20">
				<label htmlFor="plans-actions-id">Agreed Plan and Actions</label>
				<textarea
					name="plans-actions-id"
					id="plans-actions-id"
					className="form-control form-control-textarea"
					required
					rows="6"
					ref={planAction}
					placeholder="enter plan and actions"
				></textarea>
			</div>
			<div className="form-group m-t-20">
				<label htmlFor="leave-outcome-id">Leave Outcome</label>
				<textarea
					name="leave-outcome-id"
					id="leave-outcome-id"
					className="form-control form-control-textarea"
					required
					ref={outCome}
					rows="6"
					placeholder="enter leave outcome"
				></textarea>
			</div>
			<div className="form-group text-center m-t-20">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
				>
					Submit Update <i className="material-icons">keyboard_arrow_right</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
				>
					Cancel <i className="material-icons text-danger">close</i>
				</button>
			</div>
		</form>
	);
}

export default UpdateLeaveForm;
